import { useI18n } from '@i18n';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import { consumption_type_enum } from '@predium/enums';
import { translateConsumptionTypeEnum } from '@predium/i18n/client';

const RootStyle = styled(Toolbar)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

type Props = {
  availableYearsWithConsumption: number[];
  fromToYearFilter: number | 'all';
  setFromToYearFilter: (year: number | 'all') => void;
  consumptionTypeFilter: consumption_type_enum | 'all';
  setConsumptionTypeFilter: (value: consumption_type_enum | 'all') => void;
};

export default function ConsumptionListToolbar({
  availableYearsWithConsumption,
  consumptionTypeFilter,
  fromToYearFilter,
  setConsumptionTypeFilter,
  setFromToYearFilter,
}: Props) {
  const { t } = useI18n();

  return (
    <RootStyle>
      <Stack direction="row" sx={{ width: '100%', mb: 3 }}>
        <TextField
          select
          label={t('General_Year')}
          value={fromToYearFilter}
          onChange={(event) => setFromToYearFilter(event.target.value === 'all' ? 'all' : parseInt(event.target.value))}
          sx={{
            minWidth: 250,
            mr: 3,
            '.MuiOutlinedInput-input': {
              py: 1,
            },
          }}
        >
          <MenuItem key="all" value="all" sx={{ typography: 'body2', mx: 1, my: 0.5, borderRadius: 0.75 }}>
            {t('General_All')}
          </MenuItem>
          {[...availableYearsWithConsumption]
            .sort((a, b) => a - b)
            .map((option, index) => (
              <MenuItem key={index} value={option} sx={{ typography: 'body2', mx: 1, my: 0.5, borderRadius: 0.75 }}>
                {option}
              </MenuItem>
            ))}
        </TextField>

        <TextField
          select
          label={t('General_Category')}
          value={consumptionTypeFilter}
          onChange={(event) => setConsumptionTypeFilter(event.target.value as consumption_type_enum)}
          sx={{
            minWidth: 200,
            mr: 3,
            '.MuiOutlinedInput-input': {
              py: 1,
            },
          }}
        >
          <MenuItem key="all" value="all" sx={{ typography: 'body2', mx: 1, my: 0.5, borderRadius: 0.75 }}>
            {t('General_All')}
          </MenuItem>
          {Object.values(consumption_type_enum).map((consumptionType) => (
            <MenuItem
              key={consumptionType}
              value={consumptionType}
              sx={{ typography: 'body2', mx: 1, my: 0.5, borderRadius: 0.75 }}
            >
              {translateConsumptionTypeEnum(consumptionType)}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </RootStyle>
  );
}
